import { DeletePartnerNewsImageResponseSchema } from './delete-partner-news-image.schema';
export const deletePartnerNewsImageContract = {
    method: 'DELETE',
    path: '/api/v2/admin/partner-news/:id/images/:slot',
    description: 'Remove the logo or the image of a news entry',
    responseSchema: DeletePartnerNewsImageResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner news not found'
        }
    }
};

//# sourceMappingURL=delete-partner-news-image.contract.js.map